"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicDataClient = void 0;
const BaseClient_1 = require("../BaseClient");
class PublicDataClient extends BaseClient_1.BaseClient {
    constructor(appName, baseUrl) {
        super(baseUrl);
        this.appName = appName;
        this.baseUrl = baseUrl;
    }
    async publicDataGetAppManifest() {
        const response = await this.axiosInstance({
            method: 'GET',
            url: `/public-data/${this.appName}/app-manifest`,
        });
        return response.data;
    }
    async publicDataGetObject(key) {
        const response = await this.axiosInstance({
            method: 'GET',
            url: `/public-data/${this.appName}/${key}`,
        });
        return response.data;
    }
    async publicDataGetRaw(key) {
        const response = await this.axiosInstance({
            method: 'GET',
            responseType: 'text',
            url: `/public-data/${this.appName}/${key}`,
        });
        return response.data;
    }
}
exports.PublicDataClient = PublicDataClient;
